import { emitClickEvent } from './emitter';

const buildWidgetTrackingData = (widgetTracking, featureIndex) => {
  const { labels } = widgetTracking;

  return {
    ...widgetTracking,
    position: Number(featureIndex),
    status: 'clicked',
    labels: {
      ...labels,
      promo_FeatureNumber: ['99']
    }
  };
};
const buildProductTrackingData = (productTracking) => ({
  ...productTracking,
  status: 'clicked'
});

export default (
  widgetTracking,
  additionalWidgetClickTracking,
  productTracking,
  additionalProductClickTracking,
  featureIndex,
  pageName
) => {
  const event = {
    name: 'click',
    features: [
      buildWidgetTrackingData(widgetTracking, featureIndex),
      buildProductTrackingData(productTracking)
    ]
  };
  const promoAttributionFeatureValue = additionalWidgetClickTracking[
    'wk.promo_AttributionFeature'
  ][0].replace('{PAGE_NAME}', pageName);

  const additionalClickTrackingLabels = {
    ...additionalWidgetClickTracking,
    'wk.promo_AttributionFeature': [promoAttributionFeatureValue],
    ...additionalProductClickTracking
  };
  emitClickEvent(event, { promo_Click: widgetTracking.name }, additionalClickTrackingLabels);
};
